import {
  CLEAR_EDIT_TSUNAMI_EVENT,
  GET_EDIT_TSUNAMI_REQUEST,
  CREATE_EDIT_TSUNAMI_REQUEST,
  UPDATE_EDIT_TSUNAMI_REQUEST,
  EDIT_TSUNAMI_VOLCANO_REQUEST,
  EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST,
  EDIT_TSUNAMI_EARTHQUAKE_REQUEST,
  EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST,
  EDIT_TSUNAMI_REFERENCE_REQUEST,
  EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST,
  EDIT_TSUNAMI_AREA_REQUEST,
  EDIT_TSUNAMI_CAUSE_REQUEST,
  EDIT_TSUNAMI_COUNTRY_REQUEST,
  EDIT_TSUNAMI_LOCATION_REQUEST,
  EDIT_TSUNAMI_REGION_REQUEST,
  EDIT_TSUNAMI_VALIDITY_REQUEST,
  EDIT_TSUNAMI_WARNING_STATUS_REQUEST,
  EDIT_TSUNAMI_VOLCANO_SORT,
  EDIT_TSUNAMI_EARTHQUAKE_SORT,
  EDIT_TSUNAMI_REFERENCE_SORT,
  EDIT_TSUNAMI_OPEN_CONFIRMATION,
  EDIT_TSUNAMI_CANCEL_CONFIRMATION,
  EDIT_TSUNAMI_EARTHQUAKE_TOGGLE_COLUMN,
  EDIT_TSUNAMI_REFERENCE_TOGGLE_COLUMN,
  EDIT_TSUNAMI_VOLCANO_TOGGLE_COLUMN,
} from './tsunamiEventEditReducer';


export const getTsunami = ({ id, history }) => ({ type: GET_EDIT_TSUNAMI_REQUEST, id, history });
export const clearTsunami = () => ({ type: CLEAR_EDIT_TSUNAMI_EVENT });
export const createTsunami = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_EDIT_TSUNAMI_REQUEST, data, formModel, location, goBack, history,
});
export const updateTsunami = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_EDIT_TSUNAMI_REQUEST, data, id, formModel, location, goBack, history,
});
export const searchVolcanoes = ({ queryParameters, history }) => ({
  type: EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getVolcano = ({ id, history }) => ({ type: EDIT_TSUNAMI_VOLCANO_REQUEST, id, history });
export const searchEarthquakes = ({ queryParameters, history }) => ({
  type: EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getEarthquake = ({ id, history }) => ({ type: EDIT_TSUNAMI_EARTHQUAKE_REQUEST, id, history });
export const searchReferences = ({ queryParameters, history }) => ({
  type: EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getReferences = ({ id, history }) => ({ type: EDIT_TSUNAMI_REFERENCE_REQUEST, id, history });


export const getRegions = ({ history }) => ({ type: EDIT_TSUNAMI_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: EDIT_TSUNAMI_COUNTRY_REQUEST, history });
export const getAreas = ({ history }) => ({ type: EDIT_TSUNAMI_AREA_REQUEST, history });
export const getCauses = ({ history }) => ({ type: EDIT_TSUNAMI_CAUSE_REQUEST, history });
export const getValidity = ({ history }) => ({ type: EDIT_TSUNAMI_VALIDITY_REQUEST, history });
export const getLocations = ({ history }) => ({ type: EDIT_TSUNAMI_LOCATION_REQUEST, history });
export const getWarningStatuses = ({ history }) => ({ type: EDIT_TSUNAMI_WARNING_STATUS_REQUEST, history });
export const sortVolcanoes = sort => ({ type: EDIT_TSUNAMI_VOLCANO_SORT, sort });
export const sortEarthquakes = sort => ({ type: EDIT_TSUNAMI_EARTHQUAKE_SORT, sort });
export const sortReferences = sort => ({ type: EDIT_TSUNAMI_REFERENCE_SORT, sort });

export const openEditConfirmation = ({ formData }) => ({ type: EDIT_TSUNAMI_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_TSUNAMI_CANCEL_CONFIRMATION });
export const toggleEarthquakeColumns = visibleColumns => ({ type: EDIT_TSUNAMI_EARTHQUAKE_TOGGLE_COLUMN, visibleColumns });
export const toggleReferenceColumns = visibleColumns => ({ type: EDIT_TSUNAMI_REFERENCE_TOGGLE_COLUMN, visibleColumns });
export const toggleVolcanoColumns = visibleColumns => ({ type: EDIT_TSUNAMI_VOLCANO_TOGGLE_COLUMN, visibleColumns });
